import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'tf0009',
    ecrans: ['00-2']
});
